module.exports = __webpack_public_path__ + "img/altramuces.94403801.svg";